// Indicatifs téléphoniques — liste partagée (inscription, espace client, rappel, alertes).
export const PHONE_COUNTRIES = [
  { code: "+33", label: "France" },
  { code: "+32", label: "Belgique" },
  { code: "+41", label: "Suisse" },
  { code: "+352", label: "Luxembourg" },
  { code: "+1", label: "Canada" },
  { code: "+49", label: "Allemagne" },
  { code: "+34", label: "Espagne" },
  { code: "+39", label: "Italie" },
  { code: "+44", label: "Royaume-Uni" },
  { code: "+31", label: "Pays-Bas" },
  { code: "+351", label: "Portugal" },
];

// Construit un numéro international : l'indicatif choisi dans la liste + le numéro local
// (les 0 en tête sont enlevés). Si la personne a déjà tapé + ou 00, on le garde tel quel.
export const buildIntlPhone = (countryCode, raw) => {
  const r = (raw || "").trim();
  if (r.startsWith("+") || r.startsWith("00")) return r;
  return countryCode + r.replace(/^0+/, "");
};

// Retrouve l'indicatif d'un numéro international stocké (le plus long préfixe gagne).
export const splitIntlPhone = (full) => {
  const f = full || "";
  const hit = [...PHONE_COUNTRIES].sort((a, b) => b.code.length - a.code.length)
    .find((c) => f.startsWith(c.code));
  if (!hit) return { country: "+33", local: f.replace(/^\+/, "") };
  return { country: hit.code, local: f.slice(hit.code.length) };
};
